import type { HiderCard } from '../../shared/protocol';
import type { Settings } from '../../shared/constants';
import { formatDurationMs } from '../../shared/duration';

/** The hider's hand — grows as the seeker questions the map (v2 economy).
 *  Brand faces: hazard (bonus), signal (veto), near-black (curse). */
export function HiderHand({
  cards,
  onPick,
  discardMode,
  curseActive = false,
  settings,
}: {
  cards: HiderCard[];
  onPick: (c: HiderCard) => void;
  discardMode: boolean;
  curseActive?: boolean;
  /** v15 BOLT-065: live settings — the ONLY source of a shown duration. */
  settings?: Settings;
}) {
  if (cards.length === 0) {
    return (
      <div className="hider-note" data-testid="hider-hand-empty">
        No cards yet - you draw whenever the seeker plays.
      </div>
    );
  }
  return (
    <div className="card-rail" data-testid="hider-hand">
      {cards.map((c) => (
        <button
          key={c.id}
          className={`hcard hcard--${c.kind}`}
          data-testid={`hcard-${c.id}`}
          data-kind={c.kind}
          disabled={curseActive && c.kind === 'curse' && !discardMode}
          onClick={() => onPick(c)}
        >
          {/* v18 BOLT-082: no kind word for the third class — the card's own NAME
              carries it (FREEZE / SILENCE / BABEL / PORTAL / FLYING BLIND). */}
          <div className="hcard__top">{discardMode ? 'Tap to drop' : c.kind === 'bonus' ? 'Bonus' : c.kind === 'veto' ? 'Power-up' : c.label}</div>
          <div className="hcard__name">{c.label}</div>
          <div className="hcard__desc">{c.effect}</div>
          {/* v15 BOLT-065: THIS game's duration, from live settings — the
              static effect copy is numberless by law (the digit guard).
              v18 BOLT-081: one length for every timed card, so every timed
              card shows it (Portal is untimed and still shows nothing). */}
          {settings && c.kind === 'curse' && c.curse !== 'portal' && (
            <div className="hcard__dur" data-testid={`hcard-dur-${c.id}`}>
              {formatDurationMs(settings.blockDurationMs)}
            </div>
          )}
        </button>
      ))}
    </div>
  );
}
